// deps
import React, { memo } from "react";

// internal deps
import { SavingsUIRenderer } from "@swiggy-private/cart-ui";
import { useSavingsSectionRenderer, SavingsSectionProps } from "@cart-client/hooks/useSavingsSectionRenderer";

const SavingsSectionRenderer = (props: SavingsSectionProps) => {
    const { savingsLineItems, removePlanMessage } = useSavingsSectionRenderer(props);

    return (
        <SavingsUIRenderer
            renderingData={savingsLineItems}
            removePlanMessage={removePlanMessage}
            hideSectionTitle={props?.hideSectionTitle}
        />
    );
};

export default memo(SavingsSectionRenderer);
